<template>
  <a
    @click="$emit('click')"
    :href="link"
    :title="$t(platform)"
    :class="classNames"
    :data-button-code="buttonCode"
    :data-platform="platform"
    :data-adjust-platform="platform"
  />
</template>

<script>
export default {
  name: "StoreBadge",
  props: {
    link: { type: String, default: "#" },
    buttonCode: { type: String, default: "body-20200319-store_badge" },
    platform: { type: String, required: true }, // "android" or "ios"
    ctaStyle: { type: Boolean, default: false }
  },
  computed: {
    classNames() {
      return [
        this.ctaStyle ? "store-cta" : "store-button",
        `store-cta--${this.platform}`,
        `store-cta--${this.$i18n.locale}`,
        "js-adjust-link"
      ]
    }
  },
  i18n: {
    messages: {
      en: {
        android: "Get it on Google Play",
        ios: "Download on the App Store"
      },
      de: {
        android: "Jetzt bei Google Play",
        ios: "Erhätlich im App Store"
      }
    }
  }
}
</script>
